var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var LayoutIcon = function (props) { return (_jsxs("svg", __assign({ width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2' }, props, { children: [_jsx("rect", { x: '3', y: '3', width: '7', height: '7' }), _jsx("rect", { x: '14', y: '3', width: '7', height: '7' }), _jsx("rect", { x: '14', y: '14', width: '7', height: '7' }), _jsx("rect", { x: '3', y: '14', width: '7', height: '7' })] }))); };
